/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ extension: NonNullable<unknown> }} Translation_Import_Unsupported_Format_ToastInputs */



/**
* | output |
* | --- |
* | "The file format .{extension} is not supported." |
*
* @param {Translation_Import_Unsupported_Format_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_unsupported_format_toast = /** @type {((inputs: Translation_Import_Unsupported_Format_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Unsupported_Format_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le format de fichier .${i?.extension} n'est pas pris en charge.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Dateiformat .${i?.extension} wird nicht unterstützt.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il formato file .${i?.extension} non è supportato.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Формат файла .${i?.extension} не поддерживается.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El formato de archivo .${i?.extension} no es compatible.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`不支持 .${i?.extension} 文件格式。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ファイル形式「.${i?.extension}」はサポートされていません。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`.${i?.extension} फ़ाइल प्रारूप समर्थित नहीं है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O formato de arquivo .${i?.extension} não é suportado.`)
	return /** @type {LocalizedString} */ (`The file format .${i?.extension} is not supported.`)
});